import moment from "moment";

export default class WorkshopView {
  constructor(data) {
    this.id = data.id;
    if(data.workshopFile)
      this.document_url =  data.workshopFile.getUrl;
    
    this.topic = data.topic;
    this.description = data.description ? data.description : "No Description Provided";
    this.status = data.status;
    this.requested_time = moment(data.requestedTime);
    this.start_time = moment(data.startTime);
    this.end_time = moment(data.endTime);
    this.maxNumberOfAttendees = data.maxNumberOfAttendees;
    this.num_spots_left = data.maxNumberOfAttendees - data.attendees.length;
    this.attendees = data.attendees;
    this.struggle_areas = data.specialties;
    this.host = data.counselor 
      ? {
        id: data.counselor.id,
        first_name: data.counselor.firstName,
        last_name: data.counselor.lastName,
        name: `${data.counselor.firstName} ${data.counselor.lastName}`,
      } 
      : null

    this.endsOnDifferentDay = 
      this.start_time.year !== this.end_time.year 
      || this.start_time.month !== this.end_time.month
      || this.start_time.date !== this.end_time.date;
  }
}